module.exports = __webpack_public_path__ + "static/img/图标_tg.b526afd3.svg";